import { GetParkingProcessZoneInfosForValidationCodeDTO, PayTillNowClient, ZoneInfosDTO } from './../../base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { ParkingProcessInfoClient, ParkingProcessZoneInfoDTO } from 'src/app/base/models/models.swagger.generated';

@Injectable({
  providedIn: 'root',
})
export class MobileLandingService {
  public parkingProcessZoneInfo: ParkingProcessZoneInfoDTO | null = null;

  constructor(private parkingProcessInfoClient: ParkingProcessInfoClient, private payTillNowClient: PayTillNowClient) {
  }

  public loadZoneInfosForValidationCode(validationCode: string): Observable<ZoneInfosDTO> {
    return this.payTillNowClient.getParkingProcessZoneInfosForValidationCode(new GetParkingProcessZoneInfosForValidationCodeDTO({validationCode}));
  }

  public fetchParkingProcessZoneInfo(zoneId: number): Observable<ParkingProcessZoneInfoDTO> {
    if (this.parkingProcessZoneInfo?.id === +zoneId) {
      return of(this.parkingProcessZoneInfo);
    }
    return this.loadParkingProcessZoneInfo(zoneId);
  }

  private loadParkingProcessZoneInfo(zoneId: number): Observable<ParkingProcessZoneInfoDTO> {
    return this.parkingProcessInfoClient.getForeignParkingProcessZoneInfo(zoneId)
    .pipe(tap(result => {
      this.parkingProcessZoneInfo = result;
    }));
  }
}
